// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox--checkbox--OY-B6","boxed":"Checkbox--boxed--6NAdo","checked":"Checkbox--checked--0YubP"};